import {
  ContentPost,
  ContentPostData_PressRelease,
  UXBContentCategory
} from 'portals/types';
import { useContentData } from '../Content/useContentData';
import { ReleaseProps } from './PressRelease';

export const usePressReleasesData = () => {
  return useContentData<ReleaseProps, ContentPostData_PressRelease>(
    UXBContentCategory.PRESS_RELEASE,
    mapPostsToReleaseProps
  );
};

const mapPostsToReleaseProps: (
  posts: ContentPost<ContentPostData_PressRelease>[]
) => ReleaseProps[] = posts =>
  posts
    .sort(
      (a, b) =>
        new Date(b.publish_date).getTime() - new Date(a.publish_date).getTime()
    )
    .map(post => ({
      title: post.data.title,
      date: new Date(post.publish_date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      }),
      year: new Date(post.publish_date).getFullYear(),
      description: post.data.description,
      file: {
        link: post.data.downloadLink
      }
    }));
